import ServiceProvider from './container'
export { ServiceProvider }
export default ServiceProvider